import sectionTableKuboCss from '../css-snippets/section-table-kubo';

const html = `
<style>${sectionTableKuboCss}</style>
<div
  class="wrapper-container"
  id="wrapper-container-unique-id"
  data-id="unique-id"
  data-attribute="wrapper-container"
  data-background-color="#ffffff"
  style="background-color: rgb(255, 255, 255); background-image: none"
  data-enable-background-image="false"
  data-background-img=""
  data-top-padding="true"
  data-bottom-padding="true"
  data-table-header-color="#6598fa"
  data-table-odd-row-color="#f2f2f2"
>
  <div
    data-attribute="wrapper-content"
    data-center-y="true"
    class="wrapper-content container"
  >
    <div data-attribute="title-content" class="title-content">
      <h2 style="text-align: center">
        <span style="color: hsl(226, 72%, 57%)">Why VetiFlow™ Succeeds</span>
        Where Everything Else Failed:
      </h2>
    </div>
    <div data-attribute="table-kubo" class="wrap-table">
      <figure class="table" style="width: 100%">
        <table class="ck-table-resized">
          <colgroup>
            <col style="width: 17.02%" />
            <col style="width: 15.96%" />
            <col style="width: 16.17%" />
            <col style="width: 16.91%" />
            <col style="width: 16.49%" />
            <col style="width: 17.45%" />
          </colgroup>
          <thead>
            <tr>
              <th style="background-color: #6598fa; height: 80px; width: 200px">
                <p style="text-align: center">
                  <span style="color: hsl(0, 0%, 100%)"
                    ><strong>SOLUTION</strong></span
                  >
                </p>
              </th>
              <th style="background-color: #6598fa; height: 80px; width: 200px">
                <p style="text-align: center">
                  <span style="color: hsl(0, 0%, 100%)"
                    ><strong>COST</strong></span
                  >
                </p>
              </th>
              <th style="background-color: #6598fa; height: 80px; width: 200px">
                <p style="text-align: center">
                  <span style="color: hsl(0, 0%, 100%)"
                    ><strong>TIME TO WORK</strong></span
                  >
                </p>
              </th>
              <th style="background-color: #6598fa; height: 80px; width: 200px">
                <p style="text-align: center">
                  <span style="color: hsl(0, 0%, 100%)"
                    ><strong>SUCCESS RATE</strong></span
                  >
                </p>
              </th>
              <th
                style="
                  background-color: #6598fa;
                  height: 80px;
                  padding: 10px;
                  width: 188.328px;
                "
              >
                <p style="text-align: center">
                  <span style="color: hsl(0, 0%, 100%)"
                    ><strong>SAFE?</strong></span
                  >
                </p>
              </th>
              <th
                style="
                  background-color: #6598fa;
                  height: 80px;
                  padding: 10px;
                  width: 188.359px;
                "
              >
                <p style="text-align: center">
                  <span style="color: hsl(0, 0%, 100%)"
                    ><strong>DURABLE?</strong></span
                  >
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style="
                  background-color: inherit;
                  height: auto;
                  padding: 10px 15px;
                "
              >
                <p style="text-align: center">Regular Bowl + Daily Scrubbing</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">Free - $20</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">
                  Never - biofilm returns in 8 hours
                </p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">0% (biofilm always returns)</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">yes</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">Until the next day</p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  background-color: inherit;
                  height: auto;
                  padding: 10px 15px;
                "
              >
                <p style="text-align: center">Other Pet Fountains</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">$40–$150</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">
                  Temporary - get slimy within days
                </p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">30% (still develop biofilm)</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">yes</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">3-6 months (pump fails)</p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  background-color: inherit;
                  height: auto;
                  padding: 10px 15px;
                "
              >
                <p style="text-align: center">Bottled Water</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">$50+/month</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">
                  Immediate but bowl still gets slimy
                </p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">
                  40% (bowl contamination remains)
                </p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">yes</p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">Expensive forever</p>
              </td>
            </tr>
            <tr>
              <td
                style="
                  background-color: inherit;
                  height: auto;
                  padding: 10px 15px;
                "
              >
                <p style="text-align: center"><strong>VetiFlow™</strong></p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">
                  <strong>$79.99 (one-time)</strong>
                </p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">
                  <strong>Immediate - visible change within days</strong>
                </p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">
                  <strong>96%+ (based on user reports)</strong>
                </p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center"><strong>Yes</strong></p>
              </td>
              <td
                style="background-color: inherit; height: auto; padding: 10px"
              >
                <p style="text-align: center">
                  <strong>Years (5-year warranty)</strong>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </figure>
    </div>
  </div>
</div>

`;
export default html;
